import {ErrorMessage, Field, Form, Formik, useFormik} from 'formik'
import React, {useState} from 'react'
import {Form as BsForm, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useSelector, useDispatch} from 'react-redux'
import {timeZone, countries, toAbsoluteUrl, regions} from '../../../../../_metronic/helpers'
import {fetchAsyncupdateProfileDetails} from '../Overview/OverviewSlice/UpdateProfileSlice'
import {getAllUserDetails, fetchAsyncUserDetails} from '../Overview/OverviewSlice/UserDetailsSlice'
import {profileDetailsSchema} from '../../../../Utils/_helpers/ValidationSchema'
import {GeneralDataOFLoginUser} from '../../../../Utils/Auth'
import {IndustryOptions} from '../../../AdminPages/AllCellCastUser/Constant/CellCastConstant'
import Select from 'react-select'
import {createFirstLetter} from '../../../../Utils/_helpers'
import { getTimezoneOffsetLabel } from '../../../../Utils/Constant/formatDayTime';
import DatePicker from 'react-datepicker'
import moment from 'moment'
import ChangeMobileModal from './ChangeMobileModal'

const DashboardProfileOptions = [
  {
    label: 'Pro Dashboard',
    value: 'dashboard-1',
  },
  // {
  //   label: 'Dashboard Standard',
  //   value: 'dashboard-2',
  // },
  {
    label: 'Leads Dashboard',
    value: 'dashboard-leads',
  },
  {
    label: 'Starter Dashboard',
    value: 'dashboard-pro',
  },
]

const OtpNotificationOptions = [
  {
    label: 'Email',
    value: 'email',
  },
  {
    label: 'Sms',
    value: 'sms',
  },
]

const checkIsUndefined = (data: any) => {
  return data === 'undefined' ? '' : data
}

const FrontendUserProfile = () => {
  let defaultimage = toAbsoluteUrl('/media/avatars/blank.png')
  const Currency = useSelector((state: any) => state?.userDetails?.userDetails?.data?.currency)

  const [showChangeMobileModal, setShowChangeMobileModal] = useState(false)
  const [avatar, setAvatar] = useState<any>(defaultimage)
  const ownerDetail = GeneralDataOFLoginUser()?.ownerData
  const Role = GeneralDataOFLoginUser()?.user?.role

  const userValues = useSelector(getAllUserDetails)

  const initialValues: any = {
    avatar: userValues?.avatar,
    //rest for user
    firstName: userValues?.firstName || '',
    lastName: userValues?.lastName || '',
    email: userValues?.email || '',
    mobile: userValues?.mobile || '',
    companyName: Role === 'owner' ? userValues?.companyName || '' : ownerDetail?.companyName || '',
    companyWebsite:
      Role === 'owner' ? userValues?.companyWebsite || '' : ownerDetail?.companyWebsite || '',
    country: Role === 'owner' ? userValues?.country || 'au' : ownerDetail?.country || '',
    region: Role === 'owner' ? userValues?.region || '' : ownerDetail?.region || '',
    industry: Role === 'owner' ? userValues?.industry || '' : ownerDetail?.industry || '',
    language: Role === 'owner' ? userValues?.language || 'en' : ownerDetail?.language || '',
    timeZone: Role === 'owner' ? userValues?.timeZone || '' : ownerDetail?.timeZone || '',
    currency: Role === 'owner' ? userValues?.currency || '' : ownerDetail?.currency || '',
    emailCommunication:
      Role === 'owner' ? userValues?.communication.email : userValues?.communication.email,
    phoneCommunication:
      Role === 'owner' ? userValues?.communication.phone : userValues?.communication.phone,
    isUserAllow: Role === 'owner',
    rmsChatDomain: checkIsUndefined(userValues?.rmsChatDomain),
    // Safe Sending
    safeSendingStatus: userValues?.safeSending?.status ?? '',
    safeSendingStartTime: userValues?.safeSending?.startTime
      ? moment(userValues?.safeSending?.startTime, 'HH:mm').toDate()
      : null,
    safeSendingEndTime: userValues?.safeSending?.endTime
      ? moment(userValues?.safeSending?.endTime, 'HH:mm').toDate()
      : null,
    customShortLinkDomain: checkIsUndefined(userValues?.customShortLink?.domain),
    customShortLinkDomainStatus: userValues?.customShortLink?.status,
    defaultDashboardProfile:
      userValues?.defaultDashboardProfile || DashboardProfileOptions[0].value,
    isSendContactUploadNotification: userValues?.isSendContactUploadNotification,
    isSendCampaignSentScheduledNotification: userValues?.isSendCampaignSentScheduledNotification,
    isSendCampaignReportNotification: userValues?.isSendCampaignReportNotification,
    isSendLoginNotification: userValues?.isSendLoginNotification,
    otpNotificationType: userValues?.otpNotificationType || 'email',
    bounceThresholdEnable: userValues?.bounceThresholdEnable
      ? userValues?.bounceThresholdEnable
      : false,
    bounceThreshold: userValues?.bounceThreshold || 0,
    bounceNotificationEmail: userValues?.bounceNotificationEmail
      ? userValues?.bounceNotificationEmail
      : false,
    bounceNotificationSms: userValues?.bounceNotificationSms
      ? userValues?.bounceNotificationSms
      : false,
    unsubscribeThresholdEnable: userValues?.unsubscribeThresholdEnable
      ? userValues?.unsubscribeThresholdEnable
      : false,
    unsubscribeThreshold: userValues?.unsubscribeThreshold || 0,
    unsubscribeNotificationEmail: userValues?.unsubscribeNotificationEmail
      ? userValues?.unsubscribeThresholdEnable
      : false,
    unsubscribeNotificationSms: userValues?.unsubscribeNotificationSms
      ? userValues?.unsubscribeThresholdEnable
      : false,
  }

  const dispatch = useDispatch()

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_profile_details'
          aria-expanded='true'
          aria-controls='kt_account_profile_details'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0 fs-2' data-testid='txtProfileDetailsSettings'>
              Profile Details{' '}
            </h3>
          </div>
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <Formik
            initialValues={initialValues}
            validationSchema={profileDetailsSchema}
            onSubmit={async (values) => {
              let time =
                (await timeZone?.find((key: any) => key?.value === values.timeZone)?.utc[0]) ||
                values.timeZone

              values.firstName = values.firstName.replace(/^\s+|\s+$/g, '')
              values.lastName = values.lastName.replace(/^\s+|\s+$/g, '')
              const formData = new FormData()
              formData.append('companyName', values?.companyName)
              formData.append('email', values?.email)
              formData.append('mobile', values?.mobile)
              formData.append('companyWebsite', values?.companyWebsite)
              formData.append('industry', values?.industry)
              formData.append('designation', 'Developer')
              formData.append('gender', 'Male')
              formData.append('language', values?.language ?? 'en')
              formData.append('firstName', values?.firstName)
              formData.append('lastName', values?.lastName)
              formData.append('timeZone', time)
              formData.append('currency', values?.currency)
              formData.append('emailCommunication', values?.emailCommunication)
              formData.append('phoneCommunication', values?.phoneCommunication)
              formData.append('rmsChatDomain', values?.rmsChatDomain)
              formData.append('isReadFirstMessageApproval', 'true')
              formData.append('safeSendingStatus', values?.safeSendingStatus)
              formData.append('customShortLinkDomain', values?.customShortLinkDomain)
              if (values?.safeSendingStatus) {
                formData.append(
                  'safeSendingStartTime',
                  moment(values?.safeSendingStartTime).format('HH:mm')
                )
                formData.append(
                  'safeSendingEndTime',
                  moment(values?.safeSendingEndTime).format('HH:mm')
                )
              }

              formData.append('country', values?.country ?? 'au')
              formData.append('region', values?.region)
              formData.append('avatar', values?.avatar)

              formData.append('defaultDashboardProfile', values?.defaultDashboardProfile)
              formData.append(
                'isSendContactUploadNotification',
                values?.isSendContactUploadNotification
              )
              formData.append(
                'isSendCampaignSentScheduledNotification',
                values?.isSendCampaignSentScheduledNotification
              )
              formData.append(
                'isSendCampaignReportNotification',
                values?.isSendCampaignReportNotification
              )
              formData.append(
                'isSendLoginNotification',
                values?.isSendLoginNotification
              )
              formData.append('otpNotificationType', values?.otpNotificationType)

              dispatch(fetchAsyncupdateProfileDetails(formData)).then((res: any) => {
                dispatch(fetchAsyncUserDetails())
              })
            }}
          >
            {({values, setFieldValue}: any) => (
              <>
                <Form>
                  <div className='card-body border-top p-9'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-3'>
                        <span>Avatar</span>
                      </label>
                      <div className='col-lg-8'>
                        <div
                          className='image-input image-input-outline w-auto'
                          data-kt-image-input='true'
                        >
                          {typeof values.avatar !== 'object' ? (
                            values.avatar && values?.avatar !== 'undefined' ? (
                              <img src={values.avatar} alt='poster' width={125} height={125} />
                            ) : (
                              <span className='squere1'>{`${
                                userValues?.firstName !== undefined && userValues?.firstName !== ''
                                  ? userValues?.firstName?.split('')?.[0]?.toUpperCase() ?? 'C'
                                  : createFirstLetter(userValues?.name)?.firstName ?? 'C'
                              }${
                                userValues?.lastName !== undefined && userValues?.lastName !== ''
                                  ? userValues?.lastName?.split('')?.[0]?.toUpperCase() ?? 'C'
                                  : createFirstLetter(userValues?.name).lastName ?? 'C'
                              }`}</span>
                            )
                          ) : (
                            <img
                              src={URL.createObjectURL(values.avatar)}
                              alt='poster'
                              width={125}
                              height={125}
                            />
                          )}

                          <label
                            className='btn btn-icon btn-circle btn-color btn-active-color-primary w-25px h-25px bg-body shadow'
                            data-kt-image-input-action='change'
                            data-bs-toggle='tooltip'
                            data-bs-dismiss='click'
                            title='Change avatar'
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='16'
                              height='16'
                              fill='currentColor'
                              className='bi bi-pencil-fill'
                              viewBox='0 0 16 16'
                            >
                              <path d='M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z' />
                            </svg>
                            <input
                              type='file'
                              name='avatar'
                              onChange={(event: any) =>
                                setFieldValue('avatar', event?.target.files[0])
                              }
                              accept='.png, .jpg, .jpeg'
                            />
                          </label>

                          <span
                            className='btn btn-icon btn-circle btn-color btn-active-color-primary w-25px h-25px bg-body shadow'
                            data-kt-image-input-action='remove'
                            data-bs-toggle='tooltip'
                            data-bs-dismiss='click'
                            title='Remove avatar'
                            onClick={(event: any) => setFieldValue('avatar', '')}
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='25'
                              height='25'
                              fill='currentColor'
                              className='bi bi-x'
                              viewBox='0 0 16 16'
                            >
                              <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
                            </svg>
                          </span>
                        </div>
                        <div className='form-text mt-8'>Allowed file types: png, jpg, jpeg.</div>
                      </div>

                      {/* </div> */}
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-3'>
                        Full Name
                      </label>
                      <div className='col-lg-8'>
                        <div className='row'>
                          <div className='col-lg-6 fv-row'>
                            <Field
                              className={
                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                              }
                              data-testid='inputFirstName'
                              name='firstName'
                              type='text'
                              onChange={(e: any) => {
                                setFieldValue('firstName', e.target.value)
                              }}
                            />
                            <ErrorMessage name='firstName'>
                              {(msg: string) => <span className='text-danger'>{msg}</span>}
                            </ErrorMessage>
                          </div>
                          <div className='col-lg-6 fv-row'>
                            <Field
                              className={
                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                              }
                              data-testid='inputLastName'
                              name='lastName'
                              type='text'
                              onChange={(e: any) => {
                                setFieldValue('lastName', e.target.value)
                              }}
                            />
                            <ErrorMessage name='lastName'>
                              {(msg: string) => <span className='text-danger'>{msg}</span>}
                            </ErrorMessage>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-3'>Mobile</label>
                      <div className='col-lg-8 fv-row'>
                        <div className='input-group'>
                          <Field
                            className={'form-control form-control-lg form-control-solid'}
                            name='mobile'
                            type='text'
                            placeholder='Enter mobile number'
                            data-testid='inputMobile'
                            readOnly
                            onClick={() => {
                              setShowChangeMobileModal(true)
                            }}
                            style={{cursor: 'pointer'}}
                          />
                          <button
                            type='button'
                            className='btn btn-primary btn-lg'
                            onClick={() => {
                              setShowChangeMobileModal(true)
                            }}
                          >
                            Change
                          </button>
                        </div>
                        <ErrorMessage name='mobile'>
                          {(msg: string) => <span className='text-danger'>{msg}</span>}
                        </ErrorMessage>
                      </div>
                    </div>

                    {/* <div className='row mb-6'>
                    <label className='col-lg-4 col-form-label required fw-bold fs-3'>Email</label>
                    <div className='col-lg-8 fv-row'>
                      <Field
                        className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                        name='email'
                        type='text'
                      />
                      <ErrorMessage name='email'>
                        {(msg: string) => <span className='text-danger'>{msg}</span>}
                      </ErrorMessage>
                    </div>
                  </div> */}
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-3'>
                        Company
                      </label>
                      <div className='col-lg-8 fv-row'>
                        <Field
                          disabled={Role !== 'owner'}
                          className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                          name='companyName'
                          type='text'
                          data-testid='inputCompany'
                        />
                        <ErrorMessage name='companyName'>
                          {(msg: string) => <span className='text-danger'>{msg}</span>}
                        </ErrorMessage>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-3'>
                        <span className='required'>Company Website</span>
                      </label>

                      <div className='col-lg-8 fv-row'>
                        <Field
                          disabled={Role !== 'owner'}
                          className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                          name='companyWebsite'
                          type='text'
                          data-testid='inputCompanyWebsite'
                        />
                        <ErrorMessage name='companyWebsite'>
                          {(msg: string) => <span className='text-danger'>{msg}</span>}
                        </ErrorMessage>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-3'>
                        <span className='required'>Industry</span>
                      </label>
                      <div className='col-lg-8 fv-row' data-testid='ddIndustry'>
                        <Select
                          options={IndustryOptions}
                          isDisabled={Role !== 'owner'}
                          value={{value: values?.industry, label: values?.industry}}
                          onChange={(e: any) => setFieldValue('industry', e?.value)}
                          className='form-select form-select-solid form-select-lg'
                        />
                      </div>
                      <ErrorMessage name='industry'>
                        {(msg: string) => <span className='text-danger'>{msg}</span>}
                      </ErrorMessage>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-3'>
                        Currency
                      </label>

                      <div className='col-lg-8 fv-row' data-testid='ddCountry'>
                        <Select
                          options={Currency}
                          isDisabled={Role !== 'owner'}
                          value={Currency?.find((key: any) => key?.value === values?.currency)}
                          onChange={(e: any) => setFieldValue('currency', e?.value)}
                          className='form-select form-select-solid form-select-lg'
                        />
                        <ErrorMessage name='currency'>
                          {(msg: string) => <span className='text-danger'>{msg}</span>}
                        </ErrorMessage>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-3'>
                        Language
                      </label>
                      <div className='col-lg-8 fv-row' data-testid='ddLanguage'>
                        <Select
                          options={[{value: 'en', label: 'English'}]}
                          isDisabled={Role !== 'owner'}
                          value={
                            values?.language
                              ? {value: 'en', label: 'English'}
                              : {value: '', label: 'select'}
                          }
                          onChange={(e: any) => setFieldValue('language', e?.value)}
                          className='form-select form-select-solid form-select-lg'
                        />
                        <ErrorMessage name='language'>
                          {(msg: string) => <span className='text-danger'>{msg}</span>}
                        </ErrorMessage>

                        <div className='form-text'>
                          Please select a preferred language, including date, time, and number
                          formatting.
                        </div>
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-3'>
                        <span className='required'>Region</span>
                      </label>

                      <div className='col-lg-8 fv-row'>
                        <Select
                          options={regions}
                          isDisabled={Role !== 'owner' && !userValues?.isTestUser}
                          value={regions?.find((key: any) => key?.value === values?.region)}
                          onChange={(e: any) => setFieldValue('region', e?.value)}
                          className='form-select form-select-solid form-select-lg'
                        />
                        <ErrorMessage name='region'>
                          {(msg: string) => <span className='text-danger'>{msg}</span>}
                        </ErrorMessage>
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-3'>
                        <span className='required'>Country</span>
                      </label>

                      <div className='col-lg-8 fv-row'>
                        <Select
                          options={countries}
                          isDisabled={Role !== 'owner'}
                          value={countries?.find((key: any) => key?.value === values?.country)}
                          onChange={(e: any) => setFieldValue('country', e?.value)}
                          className='form-select form-select-solid form-select-lg'
                        />
                        <ErrorMessage name='country'>
                          {(msg: string) => <span className='text-danger'>{msg}</span>}
                        </ErrorMessage>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-3'>
                        Time Zone
                      </label>
                      <div className='col-lg-8 fv-row' data-testid='ddTimezone'>
                        <Select
                          options={timeZone?.map((tz: any) => {
                            const labelText = tz.label || tz.text || '';
                            if (!tz.utc?.[0]) {
                              return {
                                value: '',
                                label: labelText,
                              };
                            }
                            // Match (UTC), (UTC+...), (UTC-...) and extract the location
                            const match = labelText.match(/^\(UTC(?:[+-].*?)?\)\s*(.*)$/);
                            const location = match ? match[1] : labelText;
                            return {
                              value: tz.utc?.[0],
                              label: `${getTimezoneOffsetLabel(tz.utc?.[0])} ${location}`.trim(),
                            };
                          })}
                          isDisabled={Role !== 'owner'}
                          value={(() => {
                            const options = timeZone?.map((tz: any) => {
                              const labelText = tz.label || tz.text || '';
                              // Match (UTC), (UTC+...), (UTC-...) and extract the location
                              const match = labelText.match(/^\(UTC(?:[+-].*?)?\)\s*(.*)$/);
                              const location = match ? match[1] : labelText;
                              return {
                                value: tz.utc?.[0],
                                label: `${getTimezoneOffsetLabel(tz.utc?.[0])} ${location}`.trim(),
                              };
                            }) || [];
                            return options.find((opt: any) => opt.value === values.timeZone) || null;
                          })()}
                          onChange={(e: any) => setFieldValue('timeZone', e?.value)}
                          className='form-select form-select-solid form-select-lg'
                        />
                        <ErrorMessage name='timeZone'>
                          {(msg: string) => <span className='text-danger'>{msg}</span>}
                        </ErrorMessage>
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-3'>
                        Safe Sending
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              Safe Sending Our new feature ensures that your messages are sent only
                              within your specified time frame, based on your account's timezone. Any
                              messages scheduled outside of your selected hours will be held and
                              automatically sent when your safe sending window reopens. This feature
                              works for both API and Quick SMS only.
                            </Tooltip>
                          }
                        >
                          <i className='fas fa-exclamation-circle ms-2 fs-7'></i>
                        </OverlayTrigger>
                      </label>

                      <div className='col-lg-8 fv-row'>
                        <BsForm.Check
                          onChange={(e: any) => {
                            setFieldValue(
                              'safeSendingStartTime',
                              new Date(new Date().setHours(7, 0, 0))
                            )
                            setFieldValue('safeSendingEndTime', '')
                            setFieldValue('safeSendingStatus', !values.safeSendingStatus)
                          }}
                          checked={values.safeSendingStatus}
                          className='safe-sending-switch'
                          type='switch'
                          id='custom-switch'
                        />

                        {values?.safeSendingStatus && (
                          <div className='row mt-6'>
                            <div className='col-lg-4 required'>
                              <DatePicker
                                selected={values?.safeSendingStartTime}
                                onChange={(e: any) => {
                                  setFieldValue('safeSendingStartTime', e)
                                  setFieldValue('safeSendingEndTime', '')
                                }}
                                className=' border-0 form-control form-control-lg form-control-solid'
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                timeFormat='HH:mm'
                                dateFormat='h:mm aa'
                                placeholderText='Start Time'
                              />
                              <ErrorMessage name='safeSendingStartTime'>
                                {(msg: string) => <span className='text-danger'>{msg}</span>}
                              </ErrorMessage>
                            </div>

                            <div className='col-lg-4 required'>
                              <DatePicker
                                selected={values?.safeSendingEndTime}
                                onChange={(e: any) => setFieldValue('safeSendingEndTime', e)}
                                className=' border-0 form-control form-control-lg form-control-solid'
                                showTimeSelect
                                showTimeSelectOnly
                                timeFormat='HH:mm'
                                timeIntervals={15}
                                minTime={values?.safeSendingStartTime || new Date()}
                                maxTime={new Date(new Date().setHours(23, 59, 59))}
                                dateFormat='h:mm aa'
                                placeholderText='End Time'
                              />
                              <ErrorMessage name='safeSendingEndTime'>
                                {(msg: string) => <span className='text-danger'>{msg}</span>}
                              </ErrorMessage>
                            </div>
                          </div>
                        )}
                        <ErrorMessage name='timeZone'>
                          {(msg: string) => <span className='text-danger'>{msg}</span>}
                        </ErrorMessage>
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-3'>
                        Custom Shortlink Domain
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              Custom short link domain is a personalized web address used specifically
                              for shortened URLs
                            </Tooltip>
                          }
                        >
                          <i className='fas fa-exclamation-circle ms-2 fs-7'></i>
                        </OverlayTrigger>
                      </label>

                      <div className='col-lg-8 fv-row'>
                        <div className='row mt-6'>
                          <div className='col-lg-6'>
                            <Field
                              disabled={Role !== 'owner'}
                              className={
                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                              }
                              name='customShortLinkDomain'
                              type='text'
                            />
                            <ErrorMessage name='customShortLinkDomain'>
                              {(msg: string) => <span className='text-danger'>{msg}</span>}
                            </ErrorMessage>
                          </div>
                          <div className='col-lg-2'>
                            {values.customShortLinkDomain ? (
                              values.customShortLinkDomainStatus ? (
                                <span className='badge badge-success'>Approved</span>
                              ) : (
                                <span className='badge badge-danger'>Pending Approval</span>
                              )
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-3'>Communication</label>

                      <div className='col-lg-8 fv-row'>
                        <div className='d-flex align-items-center mt-3'>
                          <label className='form-check form-check-inline form-check-solid me-5'>
                            <input
                              data-testid='cbCommunicationEmail'
                              className='form-check-input'
                              type='checkbox'
                              defaultChecked={values?.emailCommunication}
                              onChange={(e: any) =>
                                setFieldValue('emailCommunication', !values?.emailCommunication)
                              }
                            />
                            <span className='fw-bold ps-2 fs-6'>Email</span>
                          </label>

                          <label className='form-check form-check-inline form-check-solid'>
                            <input
                              data-testid='cbCommunicationPhone'
                              className='form-check-input'
                              type='checkbox'
                              defaultChecked={values?.phoneCommunication}
                              onChange={(e: any) =>
                                setFieldValue('phoneCommunication', !values?.phoneCommunication)
                              }
                            />
                            <span className='fw-bold ps-2 fs-6'>Phone</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label  fw-bold fs-3'>
                        RMS Chat Domain
                      </label>

                      <div className='col-lg-8 fv-row'>
                        <Field
                          className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                          name='rmsChatDomain'
                          type='text'
                          data-testid='inputRMSChatDomain'
                        />
                        <ErrorMessage name='rmsChatDomain'>
                          {(msg: string) => <span className='text-danger'>{msg}</span>}
                        </ErrorMessage>
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-3'>
                        Default Dashboard Profile
                      </label>

                      <div className='col-lg-8 fv-row'>
                        <Select
                          options={DashboardProfileOptions}
                          isDisabled={Role !== 'owner'}
                          value={
                            DashboardProfileOptions?.find(
                              (key: any) => key?.value === values?.defaultDashboardProfile
                            ) || DashboardProfileOptions[0]
                          }
                          onChange={(e: any) => setFieldValue('defaultDashboardProfile', e?.value)}
                          className='form-select form-select-solid form-select-lg'
                        />
                        <ErrorMessage name='defaultDashboardProfile'>
                          {(msg: string) => <span className='text-danger'>{msg}</span>}
                        </ErrorMessage>
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-3'>
                        Send Upload Contact Notification
                        <OverlayTrigger placement='top' overlay={<Tooltip>Receive notifications when contact uploads are completed</Tooltip>}>
                          <i className='fas fa-exclamation-circle ms-2 fs-7'></i>
                        </OverlayTrigger>
                      </label>

                      <div className='col-lg-8 fv-row'>
                        <BsForm.Check
                          onChange={(e: any) => {
                            setFieldValue(
                              'isSendContactUploadNotification',
                              !values.isSendContactUploadNotification
                            )
                          }}
                          checked={values.isSendContactUploadNotification}
                          className='send-upload-contact-switch'
                          type='switch'
                          id='custom-switch'
                        />
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-3'>
                        Send Campaign Sent/Scheduled Alert
                        <OverlayTrigger placement='top' overlay={<Tooltip>Get alerts when campaigns are sent or scheduled successfully</Tooltip>}>
                          <i className='fas fa-exclamation-circle ms-2 fs-7'></i>
                        </OverlayTrigger>
                      </label>

                      <div className='col-lg-8 fv-row'>
                        <BsForm.Check
                          onChange={(e: any) => {
                            setFieldValue(
                              'isSendCampaignSentScheduledNotification',
                              !values.isSendCampaignSentScheduledNotification
                            )
                          }}
                          checked={values.isSendCampaignSentScheduledNotification}
                          className='send-campaign-sent-schedule-switch'
                          type='switch'
                          id='custom-switch'
                        />
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-3'>
                        Send Campaign Report Notification
                        <OverlayTrigger placement='top' overlay={<Tooltip>Receive detailed reports when your campaigns are completed</Tooltip>}>
                          <i className='fas fa-exclamation-circle ms-2 fs-7'></i>
                        </OverlayTrigger>
                      </label>

                      <div className='col-lg-8 fv-row'>
                        <BsForm.Check
                          onChange={(e: any) => {
                            setFieldValue(
                              'isSendCampaignReportNotification',
                              !values.isSendCampaignReportNotification
                            )
                          }}
                          checked={values.isSendCampaignReportNotification}
                          className='send-campaign-report-switch'
                          type='switch'
                          id='custom-switch'
                        />
                      </div>
                    </div>

                     <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-3'>
                        Send Login Notification
                        <OverlayTrigger placement='top' overlay={<Tooltip>Get notified when someone logs into your account</Tooltip>}>
                          <i className='fas fa-exclamation-circle ms-2 fs-7'></i>
                        </OverlayTrigger>
                      </label>

                      <div className='col-lg-8 fv-row'>
                        <BsForm.Check
                          onChange={(e: any) => {
                            setFieldValue(
                              'isSendLoginNotification',
                              !values.isSendLoginNotification
                            )
                          }}
                          checked={values.isSendLoginNotification}
                          className='send-login-report-switch'
                          type='switch'
                          id='custom-switch'
                        />
                      </div>
                    </div>

                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label fw-bold fs-3'>
                        <span className='required'>OTP Notification</span>
                        <OverlayTrigger
                          placement='top'
                          overlay={
                            <Tooltip>
                              Choose how you want to receive one-time password (OTP) notifications for account login verification
                            </Tooltip>
                          }
                        >
                          <i className='fas fa-exclamation-circle ms-2 fs-7'></i>
                        </OverlayTrigger>
                      </label>
                      <div className='col-lg-8 fv-row' data-testid='ddIndustry'>
                        <Select
                          options={OtpNotificationOptions}
                          value={{
                            value: values?.otpNotificationType,
                            label: values?.otpNotificationType,
                          }}
                          onChange={(e: any) => setFieldValue('otpNotificationType', e?.value)}
                          className='form-select form-select-solid form-select-lg'
                        />
                      </div>
                      <ErrorMessage name='industry'>
                        {(msg: string) => <span className='text-danger'>{msg}</span>}
                      </ErrorMessage>
                    </div>
                  </div>

                  <div className='card-footer d-flex justify-content-end py-6 px-9'>
                    <button
                      className='btn btn-white btn-active-light-primary me-2'
                      data-testid='btnDiscard'
                    >
                      Discard
                    </button>
                    <button
                      type='submit'
                      className='btn btn-primary'
                      data-testid='btnSaveChangesProfile'
                    >
                      Save Changes
                    </button>
                  </div>
                </Form>

                <ChangeMobileModal
                  show={showChangeMobileModal}
                  onHide={() => setShowChangeMobileModal(false)}
                  onSuccess={(newMobile) => {
                    setFieldValue('mobile', newMobile)
                    dispatch(fetchAsyncUserDetails())
                  }}
                  userEmail={userValues?.email || ''}
                />
              </>
            )}
          </Formik>
        </div>
      </div>
    </>
  )
}

export default FrontendUserProfile
